import React from 'react'

const SvgComponent = ({ svgRef, ...props }) => (
  <svg
    id="Group_1582"
    data-name="Group 1582"
    viewBox="0 0 96.156 112"
    ref={svgRef}
    {...props}
  >
    <title>
      User and heart illustration
    </title>
    <defs>
      <style>{`.cls-2{fill:#218ece}`}</style>
    </defs>
    <g id="person">
      <path
        id="Path_299"
        data-name="Path 299"
        d="M28.852 39.178A19.589 19.589 0 1 0 9.4 19.478a19.494 19.494 0 0 0 19.452 19.7"
        transform="translate(11.379)"
        fill="#d9d9d6"
      />
      <path
        id="Path_300"
        data-name="Path 300"
        className="cls-2"
        d="M67.641 20.1h-54.82A176.334 176.334 0 0 0 0 75.215h12.379c1.326-5.312 2.874-11.51 4.642-17.929l2.21 17.929h42l1.989-17.929c1.989 6.414 3.537 12.614 4.863 17.929h12.379A176.334 176.334 0 0 0 67.641 20.1"
        transform="translate(0 24.39)"
      />
    </g>
    <g id="circle-with-hearth">
      <path
        id="Path_301"
        data-name="Path 301"
        d="M72.915 53.083A26.858 26.858 0 1 1 45.947 26.3a26.952 26.952 0 0 1 26.968 26.783"
        transform="translate(23.241 31.913)"
        fill="#a4ce4d"
      />
      <path
        id="Path_302"
        data-name="Path 302"
        className="cls-2"
        d="M59.452 41.96A9.912 9.912 0 0 0 49.5 32a10.532 10.532 0 0 0-7.295 3.1l-.884.885-.884-.885a9.662 9.662 0 0 0-7.29-3.1 9.912 9.912 0 0 0-9.947 9.96 10.56 10.56 0 0 0 3.095 7.3l5.526 5.54L40 62.988l1.1 1.107 1.105-1.107 8.179-8.19 5.526-5.534a9.345 9.345 0 0 0 3.537-7.3"
        transform="translate(28.083 38.83)"
      />
      <path
        id="Path_303"
        data-name="Path 303"
        d="M32.626 63.088l8.179-8.19 5.526-5.534a9.687 9.687 0 0 0 3.095-7.3 9.912 9.912 0 0 0-9.947-9.96 10.532 10.532 0 0 0-7.295 3.1l-.884.885v28.106z"
        transform="translate(37.888 38.951)"
        fill="#0061a0"
      />
    </g>
  </svg>
)

const InsuranceBenefitsSVG = React.forwardRef((props, ref) => (
  <SvgComponent svgRef={ref} {...props} />
))

export default InsuranceBenefitsSVG
